import React, {ChangeEvent, useCallback, useEffect, useState} from "react";
import useStateRef from "react-usestateref";
import {editorToolbarOptions} from "../../InputComponents/Editor/EditorToolbarOptions";
import EditorComponent from "../../InputComponents/Editor";
import AutocompleteTextField from "../../InputComponents/AutocompleteTextField";
import SelectField from "../../InputComponents/SelectField/RenderSelectField";
import TextField from "../../InputComponents/TextField/RenderTextField";
import AutoCompleteAddressComponent from "../../InputComponents/AutoCompleteAddress";
import DragAndDrop from "../../DragAndDrop";
import {fetchOneClassifieds, updateClassified, uploadImages} from "../../../redux/Dashboard/actions";
import {Button, Typography} from "@material-ui/core";
import {connect, useSelector} from "react-redux";
import {useCookies} from "react-cookie";
import imageCompression from "browser-image-compression";
import moment from "moment";
import {RootState} from "../../../redux/store";

function EditClassifieds(props: any) {
    const category = useSelector((store: RootState) => store?.commonAppData.categories?.services) || [];

    let typeList = [
        {title: "Select Type", value: "select", disabled: true},
        {title: "Freelancer", value: "FREELANCE", disabled: false},
        {title: "Company", value: "COMPANY", disabled: false},
        {title: "Not for Profit(Free)", value: "NOT_FOR_PROFIT", disabled: false}
    ];

    let foundedList = [];
    foundedList.push({title: "Select Founded Year", value: "select", disabled: true});
    for (let i = 2030; i >= 1901; i--) {
        foundedList.push({title: i, value: i, disabled: false, selected: new Date().getFullYear() === i});
    }

    const [state, setState, refState] = useStateRef({});
    const [, setProgress, progressRef] = useStateRef(0);
    const [isActive, setIsActive] = useState(false);
    const [cookies] = useCookies(["token"]);

    const onChangeType = (e) => {
        setState({...refState?.current, type: e?.target?.value});
    };

    const setCoordinates = (coordinates) => {
        setState({...refState?.current, coordinates});
    };

    const setName = (e) => {
        setState({...refState?.current, name: e?.target?.value});
    };

    const setOwnerId = (e) => {
        setState({...refState?.current, user_id: e?.target?.value});
    };

    const setWebsite = (e) => {
        setState({...refState?.current, website: e?.target?.value});
    };

    const setPhone = (e) => {
        setState({...refState?.current, phone: e?.target?.value});
    };

    const setAddress = (address) => {
        setState({...refState?.current, ...address});
    };

    const handleFoundedChange = (e) => {
        setState({...refState?.current, founded_on: e.target.value});
    };

    const handleCategoryChange = (e) => {
        const category_id = e.target.value;
        setState({...refState?.current, primary_category: {category_id}});
    };

    const handleTagChange = (e: ChangeEvent<{ value: unknown }>, value) => {
        setState({...refState?.current, tags: value});
    };

    const getUniqueId = () => {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
            let r = Math.random() * 16 | 0, v = c == "x" ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    const onDrop = useCallback(async (files) => {
        if (files && files.length) {
            const currentIndex = refState?.current?.images?.length;
            const file_mame = files.map(file => file.name ? file.name : file.path ? file.path : "Unknown");
            files = files.map((file, i) => (
                new File([file], `${i + currentIndex}`, {type: file.type})
            ));
            const updateProgress = (p) => {
                if (p == 100) {
                    setProgress(progressRef.current + 1);
                    if (files.length == progressRef.current) {
                        setIsActive(false);
                        setProgress(0);
                    }
                }
            };
            setIsActive(true);
            let prom = [];
            for (let index in files) {
                prom.push(imageCompression(files[index], {maxSizeMB: 1, onProgress: updateProgress}));
            }
            Promise.all(prom).then(files => {
                files.map((file, i) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        setState({
                            ...refState.current, images: [
                                ...(refState?.current?.images || []),
                                {
                                    file,
                                    id: getUniqueId(),
                                    //@ts-ignore
                                    src: e.target.result,
                                    apiName: file.name,
                                    name: file_mame[i],
                                    size: file.size ? `${((file.size / 1024) * 0.0009765625).toFixed(2)} MB` : 0
                                }
                            ]
                        });
                    };
                    reader.readAsDataURL(file);
                    return file;
                });
            });
        }
        // eslint-disable-next-line
    }, []);

    const handleExpiryChange = (e: any) => {
        setState({...refState?.current, expiry_date: e.target.value});
    };

    const handleDescriptionChange = (value: any) => {
        setState({...refState?.current, description: value});
    };

    const getImagesData = (images, id) => {
        let formData = new FormData();
        images.forEach((image: any) => {
            formData.append("files", image?.file as any, image?.apiName);
        });
        formData.append("id", id);
        formData.append("type", "BIZ_SERVICES");
        return formData;
    };

    const doUpdate = () => {
        const prom = [props?.updateClassified(cookies?.token, {
            ...state,
            category_id: refState?.current?.primary_category?.category_id,
            categories: refState?.current?.tags?.map(d => d.value),
            latitude: refState?.current?.coordinates?.lat,
            longitude: refState?.current?.coordinates?.lng,
            images: refState?.current?.images?.filter(d => !d.file).map((d: any) => ({
                img_id: d?.d?.img_id,
                rank: d?.d?.rank
            }))
        })];

        if (refState?.current?.images?.filter(d => d.file)?.length) {
            prom.push(props?.uploadImages(
                cookies?.token,
                getImagesData(refState?.current?.images?.filter(d => d.file), refState?.current?.service_id)));
        }

        Promise.all(prom).then(_ => {
            alert("Post updated");
            window?.location?.reload();
        });
    };

    const handleDeleteImage = (id) => {
        if (id) {
            setState({...refState?.current, images: refState?.current?.images?.filter(d => d.id !== id)});
        }
    };

    useEffect(() => {
        const post_id = props?.match?.params?.id;
        props?.fetchOneClassifieds(cookies?.token, post_id).then(data => {
            data.images = data?.images?.map(d => ({
                id: d.img_id,
                src: d.sm,
                apiName: d.rank,
                name: "0" + d.rank,
                d
            }));
            data.categories = data?.categories?.map(d => d?.category_id);
            setState({...data, coordinates: {lat: data?.latitude, lng: data?.longitude}});
        });
        // eslint-disable-next-line
    }, [cookies?.token]);

    return (
        <div style={{margin: "10%", marginTop: "100px", marginBottom: "50px"}}>
            <Typography variant={"h5"} style={{marginBottom: "30px"}}>
                Classifieds
            </Typography>
            <div style={{margin: "10px"}}>
                <DragAndDrop
                    onDrop={onDrop}
                    images={state?.images}
                    isLoading={isActive}
                    deleteImage={handleDeleteImage}
                    accept={"image/png, image/jpg, image/jpeg"}
                    maxFiles={10}
                    label="Upload Photos (up to 10 Photos)"
                />
            </div>
            <div style={{margin: "10px"}}>
                <SelectField
                    value={state?.type}
                    onChange={onChangeType}
                    label='Type *'
                    id="type"
                    helperText={"Type is mandatory."}
                    inputId="select-type"
                    dataArray={typeList}
                />
            </div>
            <div style={{margin: "10px"}}>
                <TextField
                    value={state?.name}
                    onChange={setName}
                    id="name"
                    label="Name *"
                />
            </div>
            <div style={{margin: "10px"}}>
                <TextField
                    id="expiry"
                    type="date"
                    value={moment(state?.expiry_date).format("YYYY-MM-DD")}
                    defaultValue={moment(state?.expiry_date).format("YYYY-MM-DD")}
                    onChange={handleExpiryChange}
                    label="Expiry Date"/>
            </div>
            <div style={{margin: "10px"}}>
                <TextField
                    value={state?.user_id}
                    onChange={setOwnerId}
                    id="owner"
                    label="Owner ID"
                />
            </div>
            <div style={{margin: "10px"}}>
                <SelectField
                    label='Category *'
                    id="category"
                    onChange={handleCategoryChange}
                    value={state?.primary_category?.category_id}
                    inputId="select-category"
                    helperText={"Category is mandatory."}
                    dropdownListHeight={250}
                    dataArray={category}
                />
            </div>
            <div style={{margin: "10px"}}>
                <AutocompleteTextField
                    value={state?.tags || category.filter(d => state?.categories?.includes(d?.value))}
                    onChange={handleTagChange}
                    id="tags"
                    label={`Add additional tags`}
                    options={category}
                    inputPlaceholder="Search tags"
                />
            </div>
            <div style={{margin: "10px"}}>
                <TextField
                    value={state?.website}
                    onChange={setWebsite}
                    id="website"
                    label="Website"
                    inputMode="url"
                    placeholder="www.yourbusiness.co.uk"
                />
            </div>
            <div style={{margin: "10px"}}>
                <TextField
                    value={state?.phone}
                    onChange={setPhone}
                    id="phone"
                    label="Phone"
                    inputMode="tel"
                />
            </div>
            <div style={{margin: "10px"}}>
                <SelectField
                    label='Founding year *'
                    id="founded_on"
                    helperText={"Foundation year is mandatory."}
                    inputId="select-founded_on"
                    value={state?.founded_on}
                    onChange={handleFoundedChange}
                    dropdownListHeight={250}
                    dataArray={foundedList}
                />
            </div>
            <div style={{margin: "10px"}}>
                <EditorComponent
                    initialValue={state?.description}
                    handleDescriptionChange={handleDescriptionChange}
                    placeholder="Enter your description here..."
                    label='Describe your business/service *'
                    editorToolbarOptions={editorToolbarOptions}
                />
            </div>
            <div style={{margin: "10px"}}>
                <AutoCompleteAddressComponent
                    setAddress={setAddress}
                    defaultValue={state?.address}
                    setCoordinates={setCoordinates}
                    coordinates={state?.coordinates}
                    hideMap={false}
                    id="location"
                    autoComplete="off"
                    label='Enter the business address *'
                />
            </div>
            <div style={{margin: "10px"}}>
                <Button
                    onClick={doUpdate}
                    color={"primary"}
                    variant={"contained"}
                    style={{width: "100%"}}>
                    Update Post
                </Button>
            </div>
        </div>
    );

}

export default connect(null, {
    fetchOneClassifieds,
    updateClassified,
    uploadImages
})(EditClassifieds);